/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

/*
 * save_load_adapter - An object containing the save/load functions. It is used to implement a custom save/load algorithm.
 * reference - https://jsfiddle.net/edewhursttradingview/c1vygoeb/
 * Documentation - https://www.tradingview.com/charting-library-docs/latest/saving_loading/#api-handlers
 */
class SaveLoadAdapter {
  charts = [];

  studyTemplates = [];

  drawingTemplates = [];

  chartTemplates = [];

  localStorageKey = 'saveLoadAdapter_localStorage_charts';

  drawingTemplatesKey = 'saveLoadAdapter_localStorage_drawingTemplates';

  chartTemplatesKey = 'saveLoadAdapter_localStorage_chartTemplates';

  studyTemplatesKey = 'saveLoadAdapter_localStorage_studyTemplates';

  constructor() {
    this.readChartsFromLocalStorage();
    this.readStudyTemplatesFromLocalStorage();
    this.getAllChartTemplates();
    this.getDrawingTemplates();
  }

  getAllCharts() {
    return Promise.resolve(this.charts);
  }

  getChartContent(id) {
    for (let i = 0; i < this.charts.length; i++) {
      if (this.charts[i].id === id) {
        return Promise.resolve(this.charts[i].content);
      }
    }
    return Promise.reject();
  }

  saveChart(data) {
    if (!data.id) {
      data.id = Math.random().toString(16).slice(2);
    } else {
      this.removeChart(data.id);
    }

    data.timestamp = new Date().getTime();

    this.charts.push(data);
    this.writeChartsToLocalStorage();

    return Promise.resolve(data.id);
  }

  removeChart(id) {
    for (let i = 0; i < this.charts.length; ++i) {
      if (this.charts[i].id === id) {
        this.charts.splice(i, 1);
        this.writeChartsToLocalStorage();
        return Promise.resolve();
      }
    }

    return Promise.reject();
  }

  removeStudyTemplate(studyTemplateData) {
    for (let i = 0; i < this.studyTemplates.length; ++i) {
      if (this.studyTemplates[i].name === studyTemplateData.name) {
        this.studyTemplates.splice(i, 1);
        return Promise.resolve();
      }
    }

    return Promise.reject();
  }

  getStudyTemplateContent(studyTemplateData) {
    for (let i = 0; i < this.studyTemplates.length; ++i) {
      if (this.studyTemplates[i].name === studyTemplateData.name) {
        return Promise.resolve(this.studyTemplates[i]);
      }
    }

    console.error('st: error');

    return Promise.reject();
  }

  saveStudyTemplate(studyTemplateData) {
    for (let i = 0; i < this.studyTemplates.length; ++i) {
      if (this.studyTemplates[i].name === studyTemplateData.name) {
        this.studyTemplates.splice(i, 1);
        break;
      }
    }

    this.studyTemplates.push(studyTemplateData);
    return Promise.resolve();
  }

  getAllStudyTemplates() {
    return Promise.resolve(this.studyTemplates);
  }

  removeDrawingTemplate(toolName, templateName) {
    for (let i = 0; i < this.drawingTemplates.length; ++i) {
      if (this.drawingTemplates[i].name === templateName) {
        this.drawingTemplates.splice(i, 1);
        return Promise.resolve();
      }
    }

    return Promise.reject();
  }

  loadDrawingTemplate(toolName, templateName) {
    for (let i = 0; i < this.drawingTemplates.length; ++i) {
      if (this.drawingTemplates[i].name === templateName) {
        return Promise.resolve(this.drawingTemplates[i].content);
      }
    }

    console.error('drawing: error');

    return Promise.reject();
  }

  saveDrawingTemplate(toolName, templateName, content) {
    for (let i = 0; i < this.drawingTemplates.length; ++i) {
      if (this.drawingTemplates[i].name === templateName) {
        this.drawingTemplates.splice(i, 1);
        break;
      }
    }

    this.drawingTemplates.push({ name: templateName, content });
    return Promise.resolve();
  }

  getDrawingTemplates() {
    return Promise.resolve(this.drawingTemplates.map(template => template.name));
  }

  async getAllChartTemplates() {
    return this.chartTemplates.map(x => x.name);
  }

  async saveChartTemplate(templateName, content) {
    const theme = this.chartTemplates.find(x => x.name === templateName);

    if (theme) {
      theme.content = content;
    } else {
      this.chartTemplates.push({ name: templateName, content });
    }
  }

  async removeChartTemplate(templateName) {
    this.chartTemplates = this.chartTemplates.filter(x => x.name !== templateName);
  }

  async getChartTemplateContent(templateName) {
    const theme = {};

    const content = this.chartTemplates.find(x => x.name === templateName)?.content;

    if (content) {
      theme.content = structuredClone(content);
    }

    return theme;
  }

  readChartsFromLocalStorage() {
    this.charts = JSON.parse(localStorage.getItem(this.localStorageKey)) || [];
  }

  writeChartsToLocalStorage() {
    localStorage.setItem(this.localStorageKey, JSON.stringify(this.charts));
  }

  readStudyTemplatesFromLocalStorage() {
    this.studyTemplates = JSON.parse(localStorage.getItem(this.studyTemplatesKey)) || [];
  }

  writeStudyTemplatesToLocalStorage() {
    localStorage.setItem(this.studyTemplatesKey, JSON.stringify(this.studyTemplates));
  }
}

const saveLoadAdapter = new SaveLoadAdapter();

export default saveLoadAdapter;
